import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { TelegramIcon } from "./TelegramButton";
import { Reveal } from "../motion/Reveal";
import { CONTACT } from "../../data/content";

export const CTABand = ({ title = "Let's engineer your infrastructure.", text = "On-site technology assessments across Kerala — for businesses, institutions, industries, government organisations and communities." }) => (
  <section className="relative bg-nx-navy2 border-t border-white/10 py-20 sm:py-24 overflow-hidden" data-testid="cta-band">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,rgb(var(--nx-gold)/0.12),transparent_60%)]" />
    <div className="relative nx-wrap">
      <div className="max-w-2xl">
        <Reveal>
          <h2 className="font-marcellus text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">{title}</h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-4 text-base text-slate-400 leading-relaxed">{text}</p>
        </Reveal>
      </div>
      <Reveal delay={0.2}>
        <div className="mt-9 flex flex-col sm:flex-row sm:flex-wrap gap-4">
          <Link to="/request-a-quote" data-testid="cta-band-quote" className="group inline-flex items-center justify-center gap-3 bg-nx-gold hover:bg-nx-goldlight text-nx-navy font-semibold text-sm tracking-wide px-9 py-4 transition-all duration-300 hover:-translate-y-0.5">
            Get a Quote <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <Link to="/consultation" data-testid="cta-band-visit" className="group inline-flex items-center justify-center gap-3 border border-nx-gold/70 text-nx-goldlight hover:bg-nx-gold/10 font-semibold text-sm tracking-wide px-9 py-4 transition-all duration-300 hover:-translate-y-0.5">
            Book a Site Visit <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <Link to="/contact" data-testid="cta-band-consultation" className="group inline-flex items-center justify-center gap-3 border border-nx-gold/70 text-nx-goldlight hover:bg-nx-gold/10 font-semibold text-sm tracking-wide px-9 py-4 transition-all duration-300 hover:-translate-y-0.5">
            Request a Consultation <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} data-testid="cta-band-call" className="inline-flex items-center justify-center gap-3 border border-white/25 hover:border-nx-goldlight/70 text-white text-sm tracking-wide px-9 py-4 transition-colors">
            <Phone size={15} className="text-nx-goldlight" /> Call Now
          </a>
          <button type="button" onClick={() => window.dispatchEvent(new Event("open-enquiry-chat"))} data-testid="cta-band-telegram" className="inline-flex items-center justify-center gap-3 border border-white/25 hover:border-nx-goldlight/70 text-white text-sm tracking-wide px-9 py-4 transition-colors">
            <TelegramIcon size={15} className="text-nx-goldlight" /> Chat With Us
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
